import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { painPoints } from '../../data/content';
const routeSteps = ['See the finding.', 'Identify the clinical pathway.', 'Make the decision.', 'Monitor the patient.', 'Know when to refer.'];
export function PainPoints() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-248" data-mp="2hk89jzteuvd1">
      <div className="mx-auto max-w-5xl" data-id="element-249" data-mp="2hmky4vtoc3z2">
        <SectionHeading eyebrow="Does this sound familiar?" title="Do any of these situations happen in your practice?" subtitle="If you answered “yes” to even one of them, Kidney Disease Route™ was created for you." data-id="element-250" data-mp="2cm6oxagc6nzg" />

        <ul className="mt-9 grid grid-cols-1 gap-4 sm:mt-12 lg:grid-cols-2 lg:gap-5" data-id="element-251" data-mp="2mhqj9sf95em3">
          {painPoints.map(point => <li key={point.title} className="flex h-full flex-col rounded-3xl border border-navy-100 bg-cream p-5 sm:p-6" data-id="element-252" data-mp="s5tpvtx91yoe">
              <span className="text-2xl" aria-hidden="true" data-id="element-253" data-mp="1n5qnn198sjwv">
                {point.emoji}
              </span>
              <h3 className="mt-3 font-display text-[19px] font-bold leading-snug text-navy-900 sm:text-[22px]" data-id="element-254" data-mp="1s4k3v1fwyp0q">
                {point.title}
              </h3>
              <div className="mt-2.5 space-y-2.5" data-id="element-255" data-mp="21yalpnhjc17g">
                {point.lines.map(line => <p key={line} className="text-[14px] font-medium leading-relaxed text-navy-600 sm:text-[15px]" data-id="element-256" data-mp="26v9f23tdk44l">
                    {line}
                  </p>)}
              </div>
            </li>)}
        </ul>

        <div className="mt-12 rounded-3xl bg-navy-900 px-5 py-8 sm:mt-16 sm:px-10 sm:py-12" data-id="element-257" data-mp="2kv229p5p027t">
          <p className="mx-auto max-w-2xl text-balance text-center font-display text-[23px] font-bold leading-tight text-white sm:text-3xl" data-id="element-258" data-mp="ljrfjt2ejbm0">
            You don’t need to memorize hundreds of pages of KDIGO. You need a clinical route that
            turns evidence into decisions.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-center text-[14.5px] font-medium leading-relaxed text-navy-100 sm:text-base" data-id="element-259" data-mp="egkxx6j2gzep">
            Instead of another massive textbook to read from beginning to end, you get a structured
            system built around the decisions you actually face in practice.
          </p>

          <ol className="mx-auto mt-8 flex max-w-sm flex-col items-center gap-0" data-id="element-260" data-mp="11dwdyif9sg4d">
            {routeSteps.map((step, index) => <React.Fragment key={step} data-id="element-261" data-mp="1b593h3dliu78" data-mpi={index}>
                <li className="w-full rounded-xl bg-white/10 px-4 py-3 text-center text-[14px] font-bold text-white sm:text-[15px]" data-id="element-262" data-mp="1b47gq1n7wj9o">
                  {step}
                </li>
                {index < routeSteps.length - 1 ? <ArrowDownIcon className="my-1.5 h-4 w-4 text-brick-400" aria-hidden="true" data-id="element-263" data-mp="1l1lxk2d1za2i" /> : null}
              </React.Fragment>)}
          </ol>
        </div>

        <div className="mt-10 sm:mt-12" data-id="element-264" data-mp="23sa3tv2s97p2">
          <CTAButton label="I want to eliminate these renal doubts" subline="Get instant access for $27 • 7-day guarantee" data-id="element-265" data-mp="23pwdfzj1sjnu" />
        </div>
      </div>
    </section>;
}